import { useTranslation } from "react-i18next";

export default function useAppTranslation() {
    const [t] = useTranslation();

    const appt = (s: string | undefined | null) => {
        if (!s || s.indexOf('.') === -1 || s.indexOf(' ') > -1) return s;
        return t(s);
    }

    return appt;
}
